import Content from "../pages/Layout/Content";
import Footer from "../pages/Layout/Footer";
import Header from "../pages/Layout/Header";
import LandingMain from "../pages/Layout/LandingMain";
import AdminMain from "../pages/Admin/AdminMain";
import QnaMain from "../pages/Accommodation/AccommodationGuideMain";
import AccommodationMain from "../pages/Accommodation/AccommodationMain";
import OpenHeader from "../pages/Layout/OpenHeader";
import AdminEmployee from "../pages/Admin/AdminEmployee";
import AdminAccommodation from "../pages/Admin/AdminAccommodation";
import AdminQna from "../pages/Admin/AdminQna";
import AdminAddEmployee from "../pages/Admin/AdminAddEmployee";
import Loading from "../components/Common/Loading";
import VehicleMain from "../pages/Vehicle/Vehicle";
import AlertModal from "../components/Common/AlertModal";
import AdminVehicle from "../components/Admin/AdminVehicle";
import VehicleGuideMain from "../pages/Vehicle/VehicleGuideMain";
import AvailableVehicleCalendar from "../pages/Vehicle/AvailableVehicleCalendar";
import MeetingRoomMainPage from "../pages/MeetingRoom/MeetingRoomMainPage";
import VehicleHistory from "../pages/Vehicle/VehicleHistory";
import MyPage from "../pages/MyPage/MyPage";

import { ReactElement, Suspense, useEffect, useState } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";

import { BodyWrap } from "../styles/headerStyle";
import {
  AdminRoutes,
  CommonRoutes,
  AccommodationRoutes,
  MypageRoutes,
  VehicleRoutes,
  MeetingRoomRoutes,
} from "../system/types/type";
import {
  MainTitle,
  RaffleContent,
  SmallModalStyle,
  theme,
} from "../styles/theme";
import { ThemeProvider } from "@mui/material/styles";

import { Pc } from "../pages/Layout/ResponsiveScreen";
import { useRecoilState } from "recoil";
import {
  BranchEmployeeCheck,
  BranchEmployeeDataAtom,
  MyDataAtom,
  RoleAtom,
  RoleCheckAtom,
} from "../system/atoms";
import { Box, Grid, Modal, Typography } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { EmployeeApi } from "../system/api/EmployeeApi";
import { ErrorHandler } from "../system/ApiService";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import { CustomButtonGreen, CustomButtonPrimary } from "../styles/button";
import MeetingRoomGuidePage from "../pages/MeetingRoom/MeetingRoomGuidePage";
import { switchAccount } from "../azure/switchAccount";

function Routes(): ReactElement {
  const [isListHover, setIsListHover] = useState(false);
  const locationNow = useLocation();
  const { accounts } = useMsal();
  const [RoleCheck, setRoleCheck] = useRecoilState(RoleCheckAtom);
  const [, setAccountData] = useRecoilState(RoleAtom);
  const [myData, setMyData] = useRecoilState(MyDataAtom);

  useEffect(() => {
    setAccountData(accounts);
    //Role
    if (accounts[0]?.idTokenClaims?.roles !== undefined) {
      setRoleCheck(accounts[0]?.idTokenClaims?.roles.includes("Admin"));
    }
  }, [accounts, setAccountData, setRoleCheck]);

  // 수정
  useEffect(() => {
    if (!myData.id) {
      EmployeeApi.checkOffice365().then((res) => {
        if (!res.data.branchEmployeeCheck) {
          EmployeeApi.getmyInfo()
            .then((res) => {
              setMyData(res.data);
            })
            .catch(() => {
              setUnregisteredModalOpen(true);
            });
        }
      });
    }
  }, [setMyData, myData.id]);

  const test = {
    isLoading: true,
  };

  const [branchEmployee, setBranchEmployee] = useRecoilState(
    BranchEmployeeDataAtom
  );
  const [branchEmployeeCheck, setBranchEmployeeCheck] =
    useRecoilState(BranchEmployeeCheck);
  const [branchConfirmed, setBranchConfirmed] = useState(false);
  const [branchEmployeeData, setBranchEmployeeData] = useState<
    { [key: string]: Object }[]
  >([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [unregisteredModalOpen, setUnregisteredModalOpen] = useState(false);
  const loggedInUsernames = Array.from(new Set(accounts.map((x) => x.username)));
  function changeModalState() {
    setModalOpen(!modalOpen);
  }
  function branchAlert() {
    AlertModal("check", "계정을 설정해주세요.");
  }

  const fields: object = { text: "email", value: "id" };
  const onChange = (args: any) => {
    setBranchEmployee({
      id: args.value,
      email: args.target.itemData?.["email"],
    });
  };
  function itemTemplate(data: any): JSX.Element {
    return (
      <RaffleContent>
        <span> {data.name} </span>
        <span> {data.email} </span>
      </RaffleContent>
    );
  }

  function valueTemplate(data: any): JSX.Element {
    return (
      <RaffleContent>
        <span> {data.name} </span>
        <span> {data.email} </span>
      </RaffleContent>
    );
  }

  useEffect(() => {
    if (branchEmployee.id === 0) {
      EmployeeApi.checkOffice365().then((res) => {
        setBranchEmployeeCheck(res.data.branchEmployeeCheck);
        setBranchEmployeeData(res.data.branchEmployees);
        if (res.data.branchEmployeeCheck) {
          setModalOpen(true);
        }
        setBranchConfirmed(true);
      });
    }
  }, [branchEmployee.id, setBranchEmployeeCheck]);

  return (
    <>
      <BodyWrap>
        <ThemeProvider theme={theme}>
          {/* Header - Navigation Menu */}
          <Grid
            onMouseOver={() => setIsListHover(true)}
            onMouseLeave={() => setIsListHover(false)}
          >
            <Header />

            <Pc>
              {isListHover && locationNow.pathname !== "/" ? (
                <Grid>
                  <OpenHeader />
                </Grid>
              ) : null}
            </Pc>
          </Grid>
          {/* Body - Content */}
          <Grid>
            <Content>
              <Suspense fallback={<Loading loading={test} />}>
                {/* <Suspense fallback={<Loading loading={loadingState} />}> */}
                <Switch>
                  {/* 사이트 메인 페이지 */}
                  <Route
                    path={CommonRoutes.root}
                    component={LandingMain}
                    exact
                  ></Route>
                  {/* 휴양소 */}
                  <Route
                    path={AccommodationRoutes.root}
                    component={AccommodationMain}
                    exact
                  ></Route>
                  {/* 휴양소 예약 가이드 */}
                  <Route
                    path={AccommodationRoutes.guide}
                    component={QnaMain}
                    exact
                  ></Route>
                  {/* 나의예약 */}
                  <Route
                    path={MypageRoutes.root}
                    component={MyPage}
                    exact
                  ></Route>
                  <Route
                    path={VehicleRoutes.calendar}
                    component={AvailableVehicleCalendar}
                    exact
                  ></Route>
                  <Route
                    path={VehicleRoutes.vehicleHistory}
                    component={VehicleHistory}
                    exact
                  ></Route>
                  {/* 차량 */}
                  {branchConfirmed && branchEmployeeCheck ? (
                    <Redirect to={CommonRoutes.root} />
                  ) : (
                    <Route
                      path={VehicleRoutes.root}
                      component={VehicleMain}
                      exact
                    ></Route>
                  )}
                  {/* 차량 예약 가이드 */}
                  <Route
                    path={VehicleRoutes.guide}
                    component={VehicleGuideMain}
                    exact
                  ></Route>
                  {/* 설정 */}
                  {RoleCheck === true && [
                    <Route
                      key={AdminRoutes.root}
                      path={AdminRoutes.root}
                      component={AdminMain}
                      exact
                    />,
                    <Route
                      key={AdminRoutes.employee}
                      path={AdminRoutes.employee}
                      component={AdminEmployee}
                      exact
                    />,
                    <Route
                      key={AdminRoutes.addemployee}
                      path={AdminRoutes.addemployee}
                      component={AdminAddEmployee}
                      exact
                    />,
                    <Route
                      key={AdminRoutes.accommodation}
                      path={AdminRoutes.accommodation}
                      component={AdminAccommodation}
                      exact
                    />,
                    <Route
                      key={AdminRoutes.qna}
                      path={AdminRoutes.qna}
                      component={AdminQna}
                      exact
                    />,
                    <Route
                      key={AdminRoutes.vehicle}
                      path={AdminRoutes.vehicle}
                      component={AdminVehicle}
                      exact
                    />,
                  ]}
                  <Route
                    key={MeetingRoomRoutes.root}
                    path={MeetingRoomRoutes.root}
                    component={MeetingRoomMainPage}
                    exact
                  />
                  <Route
                    key={MeetingRoomRoutes.guide}
                    path={MeetingRoomRoutes.guide}
                    component={MeetingRoomGuidePage}
                    exact
                  />
                </Switch>
              </Suspense>
              <Modal open={modalOpen}>
                <Box sx={SmallModalStyle}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <MainTitle>지사 직원 계정 설정</MainTitle>
                      <Grid item xs={12} margin="75px 0px">
                        <DropDownListComponent
                          dataSource={branchEmployeeData}
                          placeholder="본인의 계정을 선택해주세요."
                          fields={fields}
                          name="branchEmployee"
                          itemTemplate={itemTemplate}
                          valueTemplate={valueTemplate}
                          onChange={onChange}
                        />
                      </Grid>
                      <p style={{ fontSize: "12px", color: "#888", margin: "8px 0 16px 0" }}>
                        본인의 이름이 목록에 없는 경우,{" "}
                        <a href="https://voe.weareinbody.com" target="_blank" rel="noopener noreferrer" style={{ color: "#1976d2" }}>
                          VOE 사이트
                        </a>
                        에서 관리자에게 문의해주세요.
                      </p>
                      <Grid container justifyContent="right">
                        <CustomButtonGreen
                          onClick={
                            branchEmployee.id ? changeModalState : branchAlert
                          }
                        >
                          선택
                        </CustomButtonGreen>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Modal>
              <Modal open={unregisteredModalOpen}>
                <Box sx={SmallModalStyle}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                      <MainTitle>사용자 등록 필요</MainTitle>
                      <Typography style={{ margin: "24px 0 8px", fontSize: "14px", lineHeight: 1.6 }}>
                        등록되지 않은 사용자입니다.
                        <br />
                        현재 로그인된 계정:{" "}
                        <b>{loggedInUsernames.join(", ") || "-"}</b>
                        <br />
                        본인 계정이 아니라면 다른 계정으로 다시 로그인해주세요.
                      </Typography>
                      {/* 공용 PC 등에서 다른 사람 계정이 브라우저에 남아 있으면 등록된 직원도 이 창을 본다. */}
                      <CustomButtonPrimary onClick={switchAccount}>
                        다른 계정으로 로그인
                      </CustomButtonPrimary>
                      <Typography style={{ margin: "8px 0 0", fontSize: "12px", color: "#888", lineHeight: 1.6 }}>
                        본인 계정이 맞다면{" "}
                        <a
                          href="https://voe.weareinbody.com"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#1976d2" }}
                        >
                          VOE 사이트
                        </a>
                        에서 관리자에게 사용자 등록을 문의해주세요.
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Modal>
            </Content>
          </Grid>
        </ThemeProvider>
      </BodyWrap>
      {/* Footer */}
      <Footer></Footer>
    </>
  );
}

export default Routes;
